import { FirebaseError } from 'firebase/app';

const IGNORED_ERRORS = [
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
  'auth/network-request-failed',
  'auth/user-cancelled',
  'auth/redirect-cancelled-by-user',
];

const ERROR_MESSAGES = {
  'auth/too-many-requests':
    'You have tried to login too many times consequatively. Please try again later.',
  'auth/popup-blocked':
    'Failed to login due to popups being blocked. Please verify that popup blockers are disabled for nullifyrisk.com.',
  'auth/account-exists-with-different-credential':
    'You have previously logged in with a different provider. Please try again using a different provider. If you are unable to login please contact support.',
  'auth/invalid-action-code': 'The link you clicked has expired. Please log in again.',
} as const;

export const didCancelPopup = (error: FirebaseError): boolean => {
  return (
    error.code === 'auth/popup-closed-by-user' || error.code === 'auth/cancelled-popup-request'
  );
};

export const handleFirebaseError = (error: FirebaseError): string | null => {
  let message = error.message;

  // https://firebase.google.com/docs/reference/js/auth#autherrorcodes
  if ('code' in error) {
    if (IGNORED_ERRORS.includes(error.code)) {
      return null;
    }
    if (error.code in ERROR_MESSAGES) {
      message = ERROR_MESSAGES[error.code as keyof typeof ERROR_MESSAGES];
    }
  }

  return message;
};
